import React from "react"

const ErrorPage: React.FC = () => {
  return <div>
    <h1>A fatal error has occurred. Please try reloading this page.</h1>
  </div>
}

export default ErrorPage
